export default class DtoIndustrialSiteActivityStat {
    constructor(obj) {
        this.section = obj.section
        this.libelle = obj.libelle
        this.numberInstitutions = obj.nbEstablishements
        this.headers = ['section', 'libelle', 'numberInstitutions']
    }
}